/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `CREATED` - Created
 * * `NEW` - New
 * * `WORK_IN_PROGRESS` - Work In Progress
 * * `WAITING_APPROVAL` - Waiting Approval
 * * `COMPLETED` - Completed
 * * `ARCHIVED` - Archived
 * * `REJECTED` - Rejected
 * * `LINKED` - Linked
 * @export
 */
export const ToStatusEnum = {
    Created: 'CREATED',
    New: 'NEW',
    WorkInProgress: 'WORK_IN_PROGRESS',
    WaitingApproval: 'WAITING_APPROVAL',
    Completed: 'COMPLETED',
    Archived: 'ARCHIVED',
    Rejected: 'REJECTED',
    Linked: 'LINKED'
} as const;
export type ToStatusEnum = typeof ToStatusEnum[keyof typeof ToStatusEnum];


export function instanceOfToStatusEnum(value: any): boolean {
    for (const key in ToStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(ToStatusEnum, key)) {
            if (ToStatusEnum[key as keyof typeof ToStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ToStatusEnumFromJSON(json: any): ToStatusEnum {
    return ToStatusEnumFromJSONTyped(json, false);
}

export function ToStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToStatusEnum {
    return json as ToStatusEnum;
}

export function ToStatusEnumToJSON(value?: ToStatusEnum | null): any {
    return value as any;
}

export function ToStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ToStatusEnum {
    return value as ToStatusEnum;
}

